import { type Site } from '~/data/site';

import { filter, map, pipe, sortByKey } from '@vestigas/utils';

import { type DeliveryNoteAdmin } from '../types';

import { getBulkEntityDetails } from './getBulkEntityDetails';
import { getPermittedEntityIds } from './getPermittedEntityIds';

/**
 * Returns the full permitted sites data for a given delivery note.
 * Extracts the list of permitted site ids and matches it with the full details from the fetched sites bulk data.
 * @param sgw - The sgw values of the delivery note to get the permitted sites data for.
 * @param sites - The bulk sites data to get the permitted sites data from.
 * @returns The permitted sites data for the given delivery note.
 */
export const getPermittedSitesData = (
  sgw: DeliveryNoteAdmin['sgw'],
  sites: Site[],
): Site[] => {
  if (!sgw?.length || !sites?.length) {
    return [];
  }

  const permittedSiteIds = getPermittedEntityIds(
    { sgw } as DeliveryNoteAdmin,
    'site',
  );

  // Map IDs to full site data
  const permittedSitesData = pipe(
    permittedSiteIds,
    map((id) => getBulkEntityDetails(id, sites)),
    filter(Boolean),
    (site) => sortByKey(site, 'name'),
  );

  return permittedSitesData;
};
